<template>
  <div>
    <div slot="header">
    </div>
    <div>
      <vs-alert title="Erro no processo" color="danger" v-if="error">
        {{ error }}
      </vs-alert>
    </div>
    <div>
      <vs-select
        style="margin-top: 15px;"
        name="motivocancelamento"
        width="100%"
        v-model="motivoSelecionado"
        placeholder="Selecione um Motivo de Cancelamento"
      >
        <vs-select-item
          :key="index"
          :value="option.value"
          :text="option.text"
          v-for="(option, index) in dadosCancel.reasonCancel"
        />
      </vs-select>
      <vs-button
        icon="highlight_off"
        :disabled="!this.motivoSelecionado"
        style="width: 100%; margin-top: 15px;"
        @click="openAlert()"
      >
        Cancelar Pré-Matrícula
      </vs-button>
    </div>
  </div>
</template>

<script>
import PreRegistrationService from "../services/preRegistration.js";
import {
    notifySuccess,
    getStepsInformation,
} from "../helpers/index.js";

export default {
  name: "ReasonsCancel",
  data: () => ({
    dadosCancel:{
      reasonCancel: [
        { text: "SE - Divergência Financeira", value: "09" },
        { text: "SE - Divergência Acadêmica", value: "10" },
        { text: "SE - Sem Contato", value: "11" },
        { text: "SE - Desistência Perda de Interesse", value: "12" },
        { text: "SE - Divergência no Processo", value: "13" },
        { text: "SE - Email Não Pertence ao Responsável", value: "20" },
      ],
    },
    motivoSelecionado: null,
    pre: null,
    error:null,
}),

created() {
    const stepsData = getStepsInformation();
    const preRegistrationId = stepsData.preRegistrationId;

    this.$vs.loading();
    new PreRegistrationService()
      .getPreRegistration(1, preRegistrationId)
      .then((res) => {
        this.pre = res.data;
      })
      .catch(() => {
        this.$vs.loading.close();
      });
},
methods: {
    openAlert() {
      this.$vs.dialog({
        color: "danger",
        title: "Confirmação",
        text: "Confirma o cancelamento da pré-matrícula",
        type: "confirm",
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      this.cancel(this.pre, this.motivoSelecionado);
    },
    cancel(data, reasonId) {
      this.$vs.loading();
      const payload = {
        reasonId: reasonId,
        coligateId: data.CODCOLIGADA,
        localId: data.CODLOCAL,
        attendanceId: data.CODATENDIMENTO,
        bankData: "",
      };
      this.error = null;
      new PreRegistrationService()
        .cancel(payload, data.IDPREMATRICULA)
        .then(() => {
          notifySuccess(this, "Pré cancelada com sucesso!");
          this.$router.push("/audits");
        })
        .catch((error) => {
          this.error =
            "Erro ao tentar cancelar a pré: " + error.response.data.error;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

}
}
</script>
